import React, {Fragment} from 'react'
import {Route, useParams, useRouteMatch, Switch, Redirect} from 'react-router-dom'
import Payments from 'admin/components/Payments'
import Flash from 'admin/components/shared/Flash'
import Tabs from 'admin/components/shared/Tabs'
import PaymentsPending from '../PaymentsPending'

export default () => {
  const {organisationID} = useParams()
  const match = useRouteMatch()

  return (
    <Fragment>
      <Flash />
      <Tabs
        collection={[
          {label: 'Pending', to: `/orgs/${organisationID}/payments/pending`},
          {label: 'Reconciled', to: `/orgs/${organisationID}/payments/reconciled`},
          {label: 'Ignored', to: `/orgs/${organisationID}/payments/ignored`}
        ]}
      />
      <Switch>
        <Redirect exact path={match.path} to={`/orgs/${organisationID}/payments/pending`} />
        <Route path={`${match.path}/pending`} component={PaymentsPending} />
        <Route path={`${match.path}/:state`} component={Payments} />
      </Switch>
    </Fragment>
  )
}
